module.exports = __webpack_public_path__ + "img/Singapore-5-hover.ca06a372.jpg";